import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAgentContext } from "../../contexts/AgentContext";
import { OPEN_ASSISTANT_EVENT } from "../../features/toolExperience/assistantSurface";
import AgentChat from "./AgentChat";
import AssistantLauncher from "./AssistantLauncher";

// The launcher and panel share the app shell and the same conversation draft.
export default function FloatingAgent() {
  const { pathname } = useLocation();
  const route = pathname.replace(/\/+$/, "") || "/";
  const { setAssistantVisible, assistantHasUnread } = useAgentContext();
  const [open, setOpen] = useState(false);
  const opener = useRef<HTMLElement | null>(null);
  const embedded = route === "/agent" || route === "/dashboard";
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  useEffect(() => {
    if (embedded) return;
    const show = () => {
      opener.current = document.activeElement as HTMLElement;
      setOpen(true);
    };
    window.addEventListener(OPEN_ASSISTANT_EVENT, show);
    return () => window.removeEventListener(OPEN_ASSISTANT_EVENT, show);
  }, [embedded]);
  useEffect(() => {
    if (embedded) return;
    setAssistantVisible(open);
    return () => setAssistantVisible(false);
  }, [open, embedded, setAssistantVisible]);
  const close = () => {
    setOpen(false);
    requestAnimationFrame(() =>
      (opener.current?.isConnected
        ? opener.current
        : document.querySelector<HTMLElement>(
            'header button[aria-label="Toggle menu"], header button[aria-label="Search"]',
          )
      )?.focus(),
    );
  };
  if (route === "/agent") return null;
  return (
    <>
      <AssistantLauncher hidden={open} unread={assistantHasUnread} />
      {!embedded && <AgentChat isOpen={open} onClose={close} />}
    </>
  );
}
